import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./lang/index";
import { Popup, Loading, Icon, Empty } from "vant";
import { Swipe, SwipeItem } from "vant";
import "@/assets/css/pages.css";
import "@/assets/text/text.css";

// import iView from 'view-design';
import "vant/lib/index.css";

// import api from "./api/request_list";

import env from "../env";
Vue.prototype.$env = env;

Vue.use(Swipe);
Vue.use(SwipeItem);

Vue.config.productionTip = false;
Vue.prototype._i18n = i18n;

var vues = new Vue({
  router,
  i18n,
  render: (h) => h(App),
});

Vue.prototype.$bus = vues;
vues.$mount("#app");
export default vues;
